import { BILLING_CHECKOUT_RETURN_PATH } from '@hero/core';
import { defineRoutes } from '../utils';

/**
 * Billing & subscription routes — Hero-as-seller pages mounted under
 * `/billing` in the "More" section of every unified dashboard.
 *
 * `billing_invoice` opens a specific Billing doc (the Hero-side
 * counterpart of an Invoice). `billing_change_plan` is the upgrade /
 * downgrade flow.
 */
export const billingRoutes = defineRoutes({
  /** Landing — overview of current subscription + last billing. */
  billing: {
    path: '/billing',
    isPublic: false,
  },
  /** Full Billing history list. */
  billing_history: {
    path: '/billing/history',
    isPublic: false,
  },
  /** Single Billing detail / receipt page. */
  billing_invoice: {
    path: '/billing/invoice/:id',
    isPublic: false,
    params: {} as {
      /** Billing._id */
      id: string;
    },
  },
  /** Plan picker — start a subscription or change plan. */
  billing_change_plan: {
    path: '/billing/plan',
    isPublic: false,
  },
  /** Manage addons. */
  billing_addons: {
    path: '/billing/addons',
    isPublic: false,
  },
  /**
   * Return target for Moyasar after hosted checkout. Renders the
   * "payment confirmation" page — verifying / success / failed /
   * pending — so users get a clear outcome instead of landing back
   * on the overview with a silent banner. Moyasar appends
   * `?id=<paymentId>&status=paid|failed` to the URL itself.
   *
   * Path comes from `@hero/core` so the backend renewal-cron callback
   * URL and this route stay in lockstep — see `BILLING_CHECKOUT_RETURN_PATH`.
   */
  billing_checkout_return: {
    path: BILLING_CHECKOUT_RETURN_PATH,
    isPublic: false,
  },
});
